import { EGetCoworkingsByOperatorStatus, GetCoworkingsByOperatorMappers } from './types';

export const mappers: GetCoworkingsByOperatorMappers = {
  200: state => ({
    lkUrl: state.lkUrl,
    coworkings: state.coworkings,
    message: null,
    status: EGetCoworkingsByOperatorStatus.Success,
  }),
  400: ({ message }) => ({
    lkUrl: '',
    coworkings: [],
    message,
    status: EGetCoworkingsByOperatorStatus.Error,
  }),
};
